import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_UGC_LINK_REDIRECT_WRAP_ENABLED = defineFcm('ugc_link_redirect_wrap_enabled')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				petitionDescription: { type: 'boolean' },
				movementDescription: { type: 'boolean' },
				petitionUpdate: { type: 'boolean' },
				dmResponse: { type: 'boolean' },
				comment: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		petitionDescription: false,
		movementDescription: false,
		petitionUpdate: false,
		dmResponse: false,
		comment: false,
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'UGC link processing',
		description:
			'Per-UGC-type kill switch for rewriting non-Change <a href> links in user-generated content to go through the /redirect?to=... offsite interstitial.',
		template: {
			petitionDescription: false,
			movementDescription: false,
			petitionUpdate: false,
			dmResponse: false,
			comment: false,
		},
	});
